import React from 'react';
import { createRoot } from 'react-dom/client';

import RelatedItem from '@fec/frontend/modules/content/related-item/RelatedItem.jsx';

import './related-items-list.scss';

export function init() {
  document.querySelectorAll('.js-related-items-list').forEach((container) =>
    createRoot(container).render(
      <React.StrictMode>
        <RelatedItemList
          heading={container.dataset.listHeading}
          items={JSON.parse(container.dataset.relatedItems)}
          currentArticleId={container.dataset.currentArticleId}
        />
      </React.StrictMode>,
    ),
  );
}

const RelatedItemList = ({ items = [], currentArticleId = null, heading }) => (
  <div className="related-items-list related-items-list--aron">
    {heading && <h2 className="related-items-list__heading">{heading}</h2>}

    <ul className="related-items-list__list">
      {items.map((item) => (
        <li key={item.urn} className="related-items-list__item-wrapper">
          <RelatedItem item={item} currentArticleId={currentArticleId} />
        </li>
      ))}
    </ul>
  </div>
);

export default RelatedItemList;
